import React, { Component } from 'react';

const dadataApiKey = process.env?.DADATA_API_KEY || '318c0272e1d69ceed262f4345982fc0bce695feb';

class InputCountry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
      suggestions: [],
      showSuggestions: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (value != this.state.value) {
      this.setState({
        value,
      });
    }
  }

  getInput() {
    const {
      disabled,
      name,
      placeholder,
      className,
      error,
      required
    } = this.props;
    const { value } = this.state;

    const classes = ['inp__field'];

		if (required){
      if (error && !value) classes.push('inp__field--error');
    }

    return (
      <input
        type="text"
        disabled={disabled}
        className={className || classes.join(' ')}
        placeholder={placeholder}
        name={name}
        onFocus={() => this.setState({ showSuggestions: true })}
        onChange={e => this.onChange(e.target.value)}
        onBlur={e => this.onBlur(e)}
        value={value}
      />
    );
  }

  onBlur(e) {
    const parent = this;
    setTimeout(function () {
      parent.setState({ suggestions: [] });
      parent.setState({ showSuggestions: false });
    }, 200);

    if(e?.relatedTarget?.parentNode.classList.contains('dadata-suggestions')) return;

    this.setState({ value: '' });
    this.props.onChange({type: 'onBlur'});
    this.props.onBlur();
  }

  fetchSuggestions(string) {
    fetch(
      'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/country',
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
          authorization: `Token ${dadataApiKey}`,
        },
        body: JSON.stringify({
          query: string,
          count: 10,
          "status": ["ACTIVE"]
        }),
      },
    )
      .then(response => response.json())
      .then(response => {
        this.setState({ suggestions: response.suggestions });
      })
      .catch(err => {
        console.error('Dadata request error', err);
      });
  }

  onChange(value) {
    const { onChange } = this.props;
    if (value.length > 2) this.fetchSuggestions(value);

    this.setState({ value });
    onChange({type: 'onChange', citizenship: value, citizenshipCode: ''});
  }

  getSuggestions() {
    const { suggestions, showSuggestions } = this.state;
    const { onChange } = this.props;

    if (suggestions.length && showSuggestions) {
      const suggestionsHtml = suggestions
        .filter(s => s.value)
        .map(s => {
          const countryName = s.unrestricted_value ? s.unrestricted_value : s.value;
          return (
            <button
              type="button"
              key={s.data.code}
              onMouseDown={() => onChange({type: 'getSuggestions', citizenship: countryName, citizenshipCode: s.data.alfa2})}
              className="dadata-suggestions__item"
            >
              {countryName}
            </button>
          );
        });
      return suggestionsHtml.length ? <div className="dadata-suggestions">{suggestionsHtml}</div> : null;
    }

    return null;
  }

  getIcon() {
    const { required, value } = this.props;

    if (required) {
      if (value){
        return <div className="inp__field--success-icon" />;
      } else {
        return <div className="inp__field--error-icon" />;
      }
    }

    return null;
  }

  render() {
    const { showSuggestions } = this.state;
    const { label, labelClassName } = this.props;
    const classes = [labelClassName, 'inp--dadata-suggestions'];
    if (showSuggestions) classes.push('inp--dadata-suggestions-show');

    return (
      <label className={classes.join(' ')}>
        { this.getInput() }
        <p className="inp__label">{label}</p>
        { this.getSuggestions() }
        { this.getIcon() }
      </label>
    );
  }
}

export default InputCountry;
